import { SpiEnvironment } from '@local/spi-js'
import { envFromHostname } from '../../../utils/envFromHostname'

/**
 *
 * @param hostname i.e. window.location.hostname in the browser
 */
export const getSpiEnv = (hostname: string): SpiEnvironment => {
  const env = envFromHostname(hostname)
  switch (env) {
    case 'prod':
      return 'PRODUCTION'
    case 'dev':
      return 'DEV'
    case 'preprod':
    default:
      return 'PREPROD'
  }
}
